import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles(theme => ({
  btn: ({ marginRight, marginLeft, marginTop, fontSize }) => ({
    marginRight,
    marginLeft,
    marginTop,
    padding: "3px 8px",
    fontSize: fontSize || 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
  }),
  btnDisabled: {
    backgroundColor: "#e0e0e0!important",
    color: "#ababa6!important",
  },
}));

const PrimaryButton = ({
  children,
  component,
  onClick,
  marginRight,
  marginLeft,
  dataTut,
  disabled,
  marginTop,
  fullWidth,
  onMouseDown,
  fontSize,
  endIcon,
  startIcon,
  sx,
}) => {
  const dynamicStyle = { marginRight, marginLeft, marginTop, fontSize };
  const classes = useStyles(dynamicStyle);

  return (
    <Button
      onMouseDown={onMouseDown}
      className={classes.btn}
      classes={{ disabled: classes.btnDisabled }}
      component={component}
      onClick={onClick}
      data-tut={dataTut}
      disabled={disabled}
      fullWidth={fullWidth}
      endIcon={endIcon}
      startIcon={startIcon}
      sx={sx}
    >
      {children}
    </Button>
  );
};

PrimaryButton.defaultProps = {
  marginTop: 0,
  marginRight: 0,
  marginLeft: 0,
  disabled: false,
};

PrimaryButton.propTypes = {
  marginTop: PropTypes.number,
  marginRight: PropTypes.number,
  marginLeft: PropTypes.number,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default PrimaryButton;
